var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"g-wrapper"},[_c('header-com'),_c('div',{staticStyle:{"width":"100%","height":"50px"}}),_c('iframe',{style:('border: 0;width:100%;overflow: scroll;height:'+_vm.height+'px'),attrs:{"src":_vm.link}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }